import React from "react";
import SanayiTipiYagCozucu from "../Components/product/SanayiTipiYagCozucu";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function SanayiTipiYagCozucuPage() {
    return (
        <>
            <ProductSEO
                name="Sanayi Tipi Yağ Çözücü"
                description="Ağır yağ ve kirleri endüstriyel yüzeylerde hızlıca çözen profesyonel yağ çözücü."
                slug="sanayitipiyagcozucu"
                imagePath="assets/images/20-kg/4.webp"
                price={1}
            />
            <PageHeader title={t("SANAYİ TİPİ YAĞ ÇÖZÜCÜ")} />
            <SanayiTipiYagCozucu />
        </>
    );
}

export default SanayiTipiYagCozucuPage;